import { render, staticRenderFns } from "./cddx_quan.vue?vue&type=template&id=685092d9&scoped=true&"
import script from "./cddx_quan.vue?vue&type=script&lang=js&"
export * from "./cddx_quan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "685092d9",
  null
  
)

export default component.exports